'use client';

// Libraries
import Head from 'next/head';
import { ReactElement } from 'react';
// Components
import { AuthBackground } from '@atoms/index';
import { RootLayout } from '@layout/index';
import { ForgotPasswordCard } from '@organisms/index';
// Hooks
import { useRedirectToHome } from '@hooks/index';
// Types
import { NextPageWithLayout } from '@globalTypes/index';

/**
 * A page component for the Forgot Password feature.
 * @returns {ReactElement} The Forgot Password page component.
 */
const ForgotPassword: NextPageWithLayout = () => {
  useRedirectToHome();

  return (
    <>
      <Head>
        <title>BearingAI - Forgot Password</title>
      </Head>
      <AuthBackground>
        <ForgotPasswordCard />
      </AuthBackground>
    </>
  );
};

ForgotPassword.getLayout = (page: ReactElement) => <RootLayout center>{page}</RootLayout>;

export default ForgotPassword;
